import React from 'react';
import { Folder } from 'lucide-react';
export function SolutionSection() {
  const cases = [{
    id: '01',
    title: 'Caso #1: Infidelidad Digital'
  }, {
    id: '02',
    title: 'Caso #2: La Carga Mental'
  }, {
    id: '03',
    title: 'Caso #3: El Conflicto de Suegras'
  }, {
    id: '04',
    title: 'Caso #4: La Intimidad Perdida'
  }, {
    id: '05',
    title: 'Caso #5: Secretos de Dinero'
  }];
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative overflow-hidden" data-id="element-193">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10" data-id="element-194">
        <div className="mb-16 text-center" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-mono font-bold text-noir-text mb-4 uppercase tracking-tight" data-id="element-196">
            Inventario del <span className="text-noir-alert" data-id="element-197">Dossier</span>
          </h2>
          <p className="text-noir-muted max-w-2xl mx-auto text-lg" data-id="element-198">
            Los 5 casos reales que desarmarán sus defensas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-199">
          {cases.map((c, index) => <div key={index} className="bg-noir-card border border-noir-border p-6 rounded-sm relative group hover:bg-[#141414] transition-colors" data-id="element-200">
              <div className="flex justify-between items-start mb-8" data-id="element-201">
                <Folder className="w-8 h-8 text-noir-muted group-hover:text-noir-text transition-colors" data-id="element-202" />
                <span className="bg-noir-alert text-white text-[10px] font-bold px-2 py-1 rounded-sm tracking-widest uppercase" data-id="element-203">
                  Confidential
                </span>
              </div>
              <div className="mt-auto" data-id="element-204">
                <div className="text-xs text-noir-muted font-mono mb-1" data-id="element-205">
                  FILE: {c.id}
                </div>
                <h3 className="text-lg font-mono font-bold text-noir-text uppercase" data-id="element-206">
                  {c.title}
                </h3>
              </div>
            </div>)}

          {/* Bonus Card */}
          <div className="bg-noir-crimson/20 border border-noir-alert/50 p-6 rounded-sm relative group flex flex-col justify-between" data-id="element-207">
            <div className="flex justify-between items-start mb-8" data-id="element-208">
              <Folder className="w-8 h-8 text-noir-alert" data-id="element-209" />
              <span className="bg-noir-alert text-white text-[10px] font-bold px-2 py-1 rounded-sm tracking-widest uppercase" data-id="element-210">
                Bonus
              </span>
            </div>
            <div data-id="element-211">
              <div className="text-xs text-noir-alert font-mono mb-1" data-id="element-212">
                FILE: EX
              </div>
              <h3 className="text-lg font-mono font-bold text-noir-text uppercase" data-id="element-213">
                El Veredicto
              </h3>
              <p className="text-xs text-noir-muted mt-2" data-id="element-214">
                Protocolo de cierre para una conexión real.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}